var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanzWhiteShortlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 23,
    viewBox: "0 0 126 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H11.0972C15.3808 0 18.2821 1.39926 18.2821 5.62602C18.2821 7.85178 17.1806 9.40328 15.2224 10.3603C17.9653 11.1578 19.3475 13.282 19.3475 16.1096C19.3475 20.7133 15.4672 22.6853 11.3996 22.6853H0.5V0ZM5.45306 9.17853H10.4637C12.1987 9.17853 13.4874 8.38103 13.4874 6.48152C13.4874 4.32102 11.846 3.87876 10.0822 3.87876H5.45306V9.17853ZM5.45306 18.7993H10.7517C12.7027 18.7993 14.4089 18.1613 14.4089 15.8123C14.4089 13.4633 12.9546 12.5715 10.8453 12.5715H5.45306V18.7993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8508 0H33.9262L42.3493 22.6781H37.2091L35.51 17.6248H27.0942L25.3304 22.6781H20.3125L28.8508 0ZM28.3756 13.9128H34.207L31.3705 5.58977H31.3129L28.3756 13.9128Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2998 0H49.2529V18.4803H60.2245V22.6781H44.2998V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1513 0H74.2267L82.6426 22.6781H77.5024L75.8034 17.6248H67.3803L65.6165 22.6781H60.5986L69.1513 0ZM68.6833 13.9128H74.5147L71.6782 5.58977H71.6134L68.6833 13.9128Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6006 0H89.5177L98.9198 15.2106H98.9774V0H103.614V22.6781H98.6679L89.3017 7.49653H89.2369V22.6781H84.6006V0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.523 18.7341L118.597 4.19052H107.467V0H125.191V3.93676L113.111 18.4803H125.501V22.6781H106.523V18.7341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanzWhiteShortlogo);
export default __webpack_public_path__ + "static/media/Balanz_white_shortlogo.d358c7576f29a6a8e59b341f59292edf.svg";
export { ForwardRef as ReactComponent };